import { LanguageSwitch } from "@/components/countries/norway/LanguageSwitch";
import { isWebshopClosed } from "@/utils/helpers";

import { Logo } from "../Logo";
import { Navigation } from "./components/Navigation";
import { NewsletterForm } from "./components/NewsLetterForm";
import { SocialLinks } from "./components/SocialLinks";
import footer from "./footer.module.css";

export const Footer = () => {
  return (
    <footer className={footer.footer}>
      <Logo className={footer.logo} leftAlign />
      {isWebshopClosed ? null : <NewsletterForm />}
      <Navigation />
      <LanguageSwitch className={footer.switch} />
      <SocialLinks />
    </footer>
  );
};
